import {decode} from 'html-entities'; //come back to this and import dynamically, webpack hates this atm

document.addEventListener("DOMContentLoaded", function() {
    var triggers = document.querySelectorAll('[data-modal]');
	var modal = document.getElementById("flexi-modal");
	var modal_background = document.getElementById("flexi-modal-background");
	var modal_close = document.getElementById("flexi-modal-close");
	var modal_iframe = document.getElementById("flexi-modal-iframe");
	var modal_content = document.getElementById("flexi-modal-content");

	let trap_interval = false;

	let trap = false;

	if(modal) {
		//if we've not initialized the focus trap
		if(!trap) {
			const focusTrap = require('focus-trap');
			trap = focusTrap.createFocusTrap(modal);
		}

		triggers.forEach(function(trigger){
			trigger.addEventListener('click', function(event){
				openModal(event, trap);
			});
		});

		document.addEventListener('keydown', ({key}) => {
			if( key === 'Escape'){
				closeModal(trap);
			}
		});
		
		modal_close.addEventListener('click', function(e){
			closeModal(trap);
		});

		modal_background.addEventListener('click', function(e){
			closeModal(trap);
		});

		// Any other modals here
		var newsletterModal = document.getElementById("newsletter-modal");
		if(newsletterModal && !getCookie('newsletter_modal')){
			setCookie('newsletter_modal', 'true', 7);
			openModal(newsletterModal, trap);
		}
	}

	function openModal(theTrigger, trap) {
		/**
		 * Hide unnecessary padding
		 */
		 var the_video = '';
		 var the_content = '';
		if(theTrigger.target){
			the_video = theTrigger.target.getAttribute('data-video');
			the_content = theTrigger.target.getAttribute('data-content');
		} else {
			the_video = theTrigger.getAttribute('data-video');
			the_content = theTrigger.getAttribute('data-content');
		}
		let page = document.getElementById("page");
	
		if( the_video ){
			modal_iframe.classList.remove('hidden');
		}
	
		if( the_content ){
			modal_content.classList.remove('hidden');
		}
	
		modal_iframe.innerHTML= decode(the_video);
		modal_content.innerHTML= decode(the_content);
	
		page.style.overflow = 'hidden';
		modal.classList.remove('invisible', 'opacity-0');
	
		if(the_video){
			modal_iframe.focus();
		} else {
			modal_content.focus();
		}

		//attempt to trigger focus trap
		let trap_status = triggerModalTrap(trap);

		//if the trap wasn't set
		if(!trap_status) {

			//set an interval to attempt this every 2s
			trap_interval = setInterval(triggerModalTrap, 2000, trap);
		}
	}

	function triggerModalTrap(trap) {

		//if the cookie popup has already been and interacted with
		if(document.cookie.match(/^(.*;)?\s*cookiesAcknowledged\s*=\s*[^;]+(.*)?$/)) {
			setTimeout(function() {

				//activate the trap
				trap.activate();

				//stop future intervals occuring
				clearInterval(trap_interval);

				//indicate the trap is active
				return true;
			}, 100);
		}

		//otherwise indicate the trap isn't active
		return false;
	}
	
	function closeModal(trap) {
		modal.classList.add('invisible', 'opacity-0');
		page.style.overflow = '';
		modal_iframe.innerHTML = '';
		modal_content.innerHTML = '';
		modal_iframe.classList.add('hidden');
		modal_content.classList.add('hidden');
		trap.deactivate();
	}
});